module.exports = __webpack_public_path__ + "img/yritysluottoflex.cfa35f6.png";